import { render, staticRenderFns } from "./pay-expenses.vue?vue&type=template&id=1bfb6d74"
import script from "./pay-expenses.vue?vue&type=script&lang=js"
export * from "./pay-expenses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports